export default "__VITE_ASSET__D2J4wmLk__"